<template>
    <div v-if="show" >
        <div v-if="flavour==0" :class="alertClass">
            <span style="font-size: 48px; color: green;">
                <i class="fas fa-check"></i>
            </span>
            <slot></slot>
        </div>
        <div v-if="flavour==1" :class="alertClass">
            <div class="icon-strip"><img v-if="resellerId>-1" :src="require('../assets/theme/'+resellerId+'/images/help.svg')" alt="Help" title="Help" class="icon"></div>
            <div class="alert-body"><slot></slot></div>
            <div class="clearfix"></div>    
        </div>
        <div v-if="flavour==2" :class="alertClass">
            <div class="icon-strip">
                <span class="svg__wrapper">
                    <svg>
                        <!-- <line x1="9.03" y1="15.38" x2="10.85" y2="15.38" id="Path"></line>
                        <path d="M9.94,12.65 L9.94,1.27 C9.93264834,1.1211648 10.0290046,0.986954737 10.1723775,0.946332413 C10.3157504,0.905710089 10.4681866,0.969428969 10.54,1.1 C12.54,4.68 19,16.1 19.35,17.1 C19.4828737,17.5522279 19.3939357,18.0406587 19.1101842,18.4170237 C18.8264326,18.7933886 18.3813328,19.0132995 17.91,19.0100366 L1.81,19.0100366 C1.3978538,19.009171 1.013515,18.8019758 0.786290956,18.4581235 C0.559066913,18.1142712 0.519161298,17.6794682 0.68,17.3 L7.16,4.08" ></path> -->
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="require('../assets/theme/77/images/rebrand_ui.svg') + '#attention'"></use>
                    </svg>
                </span>
                <!-- <img v-if="resellerId>-1" :src="require('../assets/theme/'+resellerId+'/images/help.svg')" alt="Help" title="Help" class="icon"> -->
            </div>
            <div class="alert-body"><slot></slot></div>
            <div class="clearfix"></div>    
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            show: { 
                type: Boolean,
                required: false,
                default: true 
            },
            flavour: {
                type: Number,
                required: false,
                default: 0
            },
            resellerId: {
                type: Number,
                required: false,
                default: 0
            }
        },
        computed: {
            alertClass() {
                if (this.flavour == 0) {
                    return 'alert alert-success'
                }

                if (this.flavour == 1) {
                    return 'alert'
                }

                if (this.flavour == 2) {
                    return 'alert--danger'
                }
            }
        }
    }
</script>
<style>
svg {
    height: 2rem;
    width: 2rem;
}
.svg__wrapper {
    height: 1.5rem;
    width: 1.5rem;
    --svg-stroke-width: 2px;
    --svg-size: 1.5rem;
    /*vertical-align: middle;*/
    display: block;
    fill: none;
    stroke: currentColor;
    stroke-width: 2px;
    stroke-linejoin: round;
    position: absolute;
}
</style>